import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Check = (props) => (
  <Icon viewBox="0 0 7 6" {...props}>
    <g>
      <title>check</title>
      <path d="M.007 3.343c.027.206.128.4.293.534l2.433 1.961a.708.708 0 0 0 1.041-.157l3.074-4.385A.854.854 0 0 0 6.705.164.71.71 0 0 0 5.659.32L3.033 4.064l-1.839-1.48a.71.71 0 0 0-1.045.163.86.86 0 0 0-.142.596"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Check;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Check.js